import { Injectable } from '@angular/core';
import posthog from 'posthog-js';

import { ModalView } from '@libs/types';

@Injectable({
  providedIn: 'root',
})
export class ModalAnalyticsService {
  sendModalView(modal: ModalView) {
    posthog.capture('employer:modal_analytics:modal_view', {
      modal_name: modal.name,
      modal_placement: modal.placement,
      step_name: modal?.stepName ?? null,
      step_number: modal?.stepNumber ?? null,
      total_steps: modal?.totalSteps ?? null,
    });
  }
}
